import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportJobOrderCustomerLocationService extends GenericService {
    constructor() {
        super('/reports/job_order_customer_location', axiosInstance);
    }
}

export default new ReportJobOrderCustomerLocationService(); 